import { useEffect } from "react";
import { ContactQrStep } from "@/components/contact/ContactQrStep";
import { IntakeForm } from "@/components/contact/IntakeForm";
import { useContact } from "@/context/ContactContext";

export function ContactModal() {
  const { open, mode, intakeContext, submittedSummary, closeContact } = useContact();

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open || !intakeContext) return null;

  const isDone = mode === "intake-done";

  return (
    <div
      className="fade-in fixed inset-0 z-50 flex flex-col justify-end bg-ink-900/50 backdrop-blur-[2px]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-title"
      onClick={closeContact}
    >
      <div
        className="relative mx-auto w-full max-w-phone animate-slide-up rounded-t-[32px] bg-paper px-6 pb-9 pt-2.5 shadow-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mb-5 mt-2 h-1 w-9 rounded-full bg-ink-200" />

        <button
          type="button"
          onClick={closeContact}
          className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-surface-50 text-ink-700"
          aria-label="关闭"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
            <path
              d="M3 3l8 8M11 3l-8 8"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {isDone ? (
          <ContactQrStep summary={submittedSummary} showCopySummary />
        ) : (
          <>
            <div className="mb-4 text-center">
              <p className="kicker mb-2">先说说你的情况</p>
              <h2
                id="contact-title"
                className="text-xl font-bold leading-tight tracking-tight text-ink-900"
              >
                方便顾问更快帮上你
              </h2>
            </div>
            <IntakeForm ctx={intakeContext} />
          </>
        )}
      </div>
    </div>
  );
}
